<div>
  <app-title-banner [title]="titleBanner()" titleClass="w-full p-6" >
    @if (fromEmployerView()) {
      <div slot="button-back-content" class="items-left"><ng-content></ng-content></div>
    }
  </app-title-banner>
  <app-nav-bar-menu
    [cards]="selectionCards()"
    [cardView]="cardView()"
    (cardSelected)="onSelectedRoutes($event)">
  </app-nav-bar-menu>
  <div class="dashboard-content mt-4">
    <router-outlet></router-outlet>
  </div>
</div>
